import { AuthService } from "@/services/auth-service.js";
import { checkError } from "@/config/errors.js";

export default {
  namespaced: true,

  state: {
    companySettings: JSON.parse(localStorage.getItem("companySettings")) || [], // Load from local storage
    currencyCode: localStorage.getItem("currency_code") || null,
    taxType: localStorage.getItem("tax_type") || null,
    dateFormat: localStorage.getItem("date_formate") || null,
    error: null,
    loader: false,
  },

  mutations: {
    setCompanySettings(state, payload) {
      console.log("Setting company settings in state:", payload);
      state.companySettings = payload;
      localStorage.setItem("companySettings", JSON.stringify(payload));

      const currencySetting = payload.data.find(
        (setting) => setting.key === "currency_code",
      );
      const taxSetting = payload.data.find(
        (setting) => setting.key === "tax_type",
      );
      const dateFormatSetting = payload.data.find(
        (setting) => setting.key === "date_formate",
      );

      if (currencySetting) {
        state.currencyCode = currencySetting.value;
        localStorage.setItem("currency_code", currencySetting.value);
      }
      if (taxSetting) {
        state.taxType = taxSetting.value;
        localStorage.setItem("tax_type", taxSetting.value);
      }

      if (dateFormatSetting) {
        state.dateFormat = dateFormatSetting.value;
        localStorage.setItem("date_formate", dateFormatSetting.value);
      }
    },
    setLoader(state, payload) {
      state.loader = payload;
    },
    setError(state, payload) {
      state.error = payload;
    },
    clearError(state) {
      state.error = null;
    },
  },

  actions: {
    async getCompanySettings({ commit }) {
      commit("setLoader", true);
      commit("clearError");
      try {
        const response = await AuthService.getCompanySettings();
        commit("setCompanySettings", response.data);
      } catch (error) {
        commit(
          "setError",
          checkError.errorFormatting(error.response?.data || error.message),
        );
      } finally {
        commit("setLoader", false);
      }
    },
  },

  getters: {
    companySettings(state) {
      return state.companySettings;
    },
    currencyCode(state) {
      return state.currencyCode;
    },
    dateFormat(state) {
      return state.dateFormat;
    },
    taxType(state) {
      return state.taxType;
    },
    loading(state) {
      return state.loader;
    },
    errors(state) {
      return state.error;
    },
  },
};
